<script setup>
import { ref, computed } from 'vue'
import { useAppStore } from '~/store/main'

defineProps({
  programTitle: { type: String, default: '' },
  actualities: {
    type: Array,
    default: () => [],
  },
  linkLabel: { type: String, default: '' },
  linkName: { type: String, default: '' },
})

const store = useAppStore()
const getIsDesktop = computed(() => store.getIsDesktop)
const getHeaderHeight = computed(() => store.getHeaderHeight)

const toggleNext = ref(true)

const { t } = useI18n()
const localePath = useLocalePath()
</script>

<template>
  <div class="program">
    <h2
      class="header is_root text_minor_2"
      :style="{ top: getHeaderHeight + 'px' }"
    >
      {{ programTitle }}
    </h2>

    <div v-if="actualities.length">
      <div
        v-for="(actuality, index) in actualities.slice(0, 5)"
        :key="actuality.node.id + index"
      >
        <ColapsRow
          :collapse-id="`${actuality.node.id + index}`"
          :title="actuality.node.title"
          :actuality="actuality.node.NoticeFields"
          :active-slug="actuality.node.slug"
          :img="actuality.node.featuredImage || {}"
          :is-open="getIsDesktop && index < 0"
        />
      </div>

      <a
        v-if="toggleNext && actualities.length > 5"
        href="#"
        class="link text_minor toggleLink"
        @click.prevent="toggleNext = false"
      >
        {{ t('general.next') }}
      </a>

      <Transition name="fade">
        <div v-if="!toggleNext" class="collapsed">
          <div
            v-for="(actuality, index) in actualities.slice(5)"
            :key="actuality.node.id + index"
          >
            <ColapsRow
              :collapse-id="`${actuality.node.id + index}`"
              :title="actuality.node.title"
              :actuality="actuality.node.NoticeFields"
              :active-slug="actuality.node.slug"
              :img="actuality.node.featuredImage || {}"
              :is-open="getIsDesktop && index < 0"
            />
          </div>
        </div>
      </Transition>

      <a
        v-if="!toggleNext"
        href="#"
        class="link text_minor toggleLink"
        @click.prevent="toggleNext = true"
      >
        {{ t('general.close') }}
      </a>
    </div>

    <NuxtLink
      v-if="linkName && linkLabel"
      class="link text_minor_3 program__link"
      :to="localePath({ name: linkName })"
    >
      {{ linkLabel }}
    </NuxtLink>
  </div>
</template>

<style scoped lang="scss">
.header {
  border-bottom: 1px solid $color-5;
  padding-bottom: 19px;
  padding-top: 19px;
  margin: 0;

  position: sticky;
  background-color: $color-1;
  transition: background-color 0.3s;
  z-index: 1;
  width: 100%;
}

.program {
  &__link {
    width: fit-content;
    display: block;
    margin: 16px auto 0 auto;
  }
}

.toggleLink {
  display: block;
  width: fit-content;
  margin: 10px auto;
}

.fade-enter-active,
.fade-leave-active {
  transition: all 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
  max-height: 0;
  overflow: hidden;
}

.fade-enter-to,
.fade-leave-from {
  opacity: 1;
  max-height: 2000px;
}
</style>
